import { copyOfObject } from '../constants';

const copyObjectAndRemoveKey = (obj = {}, key) => {
    const copy = copyOfObject(obj);
    if (Array?.isArray(key)) {
        key.forEach((deleteKey) => {
            delete copy?.[deleteKey];
        });
    } else if (key) delete copy?.[key];
    return copy;
};
export default copyObjectAndRemoveKey;
export const getChildBedIntialiser = (val) => {
    if (typeof val === 'boolean') {
        return val ? 'child_with_bed' : 'child_without_bed';
    }
    return '';
};

export const offlinePrefilleFormObjectGenerator = (data, area) => {
    if (data && Object?.keys(data)?.length > 0) {
        return {
            area: area || { label: '', value: '' },
            starRating: data?.starRating || '',
            name: data?.name || '',
            roomType: data?.roomType || '',
            mealType: data?.mealType || '',
            numberOfNight: data?.numberOfNight || '',
            costPrice: data?.costPrice,
            sellingPrice: data?.sellingPrice,
            supplier: {
                name: data?.supplierName,
                label: `${data?.supplier} ${data?.supplierEmail} ${data?.supplierName}`,
                email: data?.supplierEmail,
                code: data?.supplier
            },
            childWithBed: getChildBedIntialiser(data?.childWithBed),
            remarks: data?.remarks || ''
        };
    }

    return {};
};

export const convertUrl = (url = '', arr = []) => {
    let returnUrl = `${url}?`;
    arr.forEach((item, index) => {
        if (index !== arr.length - 1) {
            returnUrl += `code=${item}&`;
        } else {
            returnUrl += `code=${item}`;
        }
    });
    return returnUrl;
};
